export const BUILD_VERSION = '2268d6723e3f4abe417c2ca1029a6e206b33fe50';
